"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IpAuditStatus {
}
exports.IpAuditStatus = IpAuditStatus;
//# sourceMappingURL=IpAuditStatus.js.map